import { describeFields, FieldWidget } from '../common/fields';
import { StreamSchema } from './schemas';

export const STREAM_FIELDS = describeFields(StreamSchema, {
  course: {},
  streamId: {},
  groupCode: {},
  scheduleLink: {},
  basePermissions: {},
  gradYear: {},
  groupName: {},
  type: {},
  priceId: { widget: FieldWidget.Select },
  slackIds: {},
  separatelyBilled: { widget: FieldWidget.Text },
  active: {},
  orderedLessons: {},
});
